import React, { memo } from 'react'

import { length } from 'ramda'

import Picture from 'components/Picture'

import styles from './Gallery.scss'

const IMAGE_SIZE = 120

type GalleryProps = {
  images: string[]
  defaultImage: string
  width?: number,
  height?: number
}

export const Gallery = ({
  images = [],
  defaultImage = '',
  width = IMAGE_SIZE,
  height = IMAGE_SIZE,
  ...rest
}: GalleryProps) => {
  const imagesCount = length(images) ?? 1
  if (imagesCount <= 1)
    return <Picture src={defaultImage}
      width={width}
      height={height}
      {...rest} />
  const itemSize = width / imagesCount
  return (
    <div className={styles.container}
      style={{ width: `${width}px`, height: `${height}px` }}>
      {images.map((image: string) => (
        <div key={image}
          className={styles.container__block}
          style={{ width: `${itemSize}px` }}>
          <div className={styles.container__image}>
            <Picture src={image}
              height={height}
              width={width}
              {...rest} />
          </div>
        </div>
      ))}
    </div>
  )
}

export default memo(Gallery)
